import styled from "styled-components";

export const Line = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  height: ${({ theme }) => theme.borders.width.xs2};
  background-color: ${({ theme }) => theme.colors.neutral[90]};
  z-index: -1;
`;
